'use strict'

var Accordion = require('./Accordion.js');

function init() {
	if (!document.querySelectorAll('.partner').length) return;

	var partners = {
		el: document.querySelectorAll('.partner'),
		all: []
	};
	var certFilter = {
		el: document.querySelector('.partners__certSelector')
	};
	var stateFilter = {
		el: document.querySelector('.partners__stateSelector'),
		opt: document.querySelectorAll('.partners__stateSelector option')
	}
	var states = [];

	function Partner(el) {
		this.el = el;
		this.hide = function() {
			if (this.el.classList) {
				this.el.classList.add('partner--hidden');
			} else {
				this.el.className += ' partner--hidden';
			}
		}
		this.unhide = function() {
			if (this.el.classList) {
				this.el.classList.remove('partner--hidden');
			} else {
				this.el.className = this.el.className.replace(new RegExp('(^|\\b)' + 'partner--hidden'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		}
		this.build = function() {
			if (this.el.getAttribute('data-cert-inside') === 'true') {
				this.inside = true;
			}
			if (this.el.getAttribute('data-cert-outside') === 'true') {
				this.outside = true;
			}
			if (this.el.getAttribute('data-cert-foa') === 'true') {
				this.foa = true;
			}
			if (this.inside && (this.outside)) {
				this.both = true;
			}

			var _states = partners.el[i].querySelectorAll('.partner__statesInner li');
			for (var s = 0; s < _states.length; s++) {
				var _state = _states[s].textContent.trim();
				this[_state] = true;

				if (states.indexOf(_state) === -1) {
					states.push(_state);
				}
			}
		}
	}

	// Build Partners
	for (var i = 0; i < partners.el.length; i++) {
		partners.all.push(new Partner(partners.el[i]));
		partners.all[i].build();
	}

	// Disable states without partners
	for (var i = 0; i < stateFilter.opt.length; i++) {
		if (states.indexOf(stateFilter.opt[i].value) === -1 && (stateFilter.opt[i].value !== ' ')) {
			stateFilter.opt[i].setAttribute('disabled', 'true');
		}
	}

	function filterPartners(arr) {
		for (var i = 0; i < arr.length; i++) {
			var certFilterValue = (
				certFilter.el.value !== ' '
				? arr[i][certFilter.el.value]
				: true
			);
			var stateFilterValue = (
				stateFilter.el.value !== ' '
					? arr[i][stateFilter.el.value]
					: true
			);

			if (certFilterValue && (stateFilterValue)) {
				arr[i].unhide();
			} else {
				arr[i].hide();
			}
		}
	}

	// When user selects cert, hides partners without that cert
	certFilter.el.addEventListener('change', function() {
		filterPartners(partners.all);
	});

	// When user selects state, hides partners without that state
	stateFilter.el.addEventListener('change', function() {
		filterPartners(partners.all);
	});

	var partnerAccordion = new Accordion({
		component: 'partner',
		trigger: 'partner--trigger',
		active: 'partner--active'
	});
	partnerAccordion.activate();
}

module.exports = {
	init: init
}
